//import './App.css';
import Header from "../components/Header";
import Nav from "../components/Nav";
import { Hdng,S } from '../components/styling/header.style';

function Home() {
  return (
    <>
    <Header><Hdng>STETH<S>AIM</S></Hdng></Header>
    <Nav></Nav>
    
    </>
  );
}

export default Home;
